export const configProject = {
  colorPrimary: "rgba(137, 95, 220, 1)",
  colorLink: "rgba(137, 95, 220, 1)",
  colorMenuBackground: "rgb(255,255,255)",
  colorTextMenu: "black",
  colorTextMenuSelected: "black",
  colorBgHeader: "rgba(95, 75, 151, 1)",
  // Gradiente do header — roxo fosco/desaturado (amethyst), sem brilho neon.
  colorBgHeaderGradient: "linear-gradient(95deg, #5f4b97 0%, #74539e 100%)",
};
